<template>
    <div>
        <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Kotizacija: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <skup-kotizacija-forma
                        :disabled="false"
                        :id="id"
                        :modal="false"
                        :action="'edit'"
                        @returnData="setData"
                >
                </skup-kotizacija-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupKotizacijaForma from "@/views/pages/Skupovi/SkupoviKotizacije/SkupKotizacijaForma";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
export default {
name: "SkupKotizacijaEdit",
    components: {
        SkupKotizacijaForma,
        SkupoviNavigation
    },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.kotizacija_id,
            skup_id: this.$route.params.skup_id,
            skup: {},
            naziv: ''
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/kotizacije',
                    name: 'Kotizacije'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/kotizacije/' + this.id,
                    name: 'Kotizacija: ' + this.naziv
                },
                {
                    path: '/skupovi/' + this.skup_id + '/kotizacije/' + this.id + '/edit',
                    name: 'Uredi kotizaciju: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.kotizacije.naziv + ' | ' + data.kotizacije.vrste_kotizacija.naziv
            this.setBreadcrumbs()
        },

    },
    mounted() {
    }
}
</script>

<style scoped>

</style>